import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { fromJS } from "immutable";
import ReportAction from "../actions/ReportAction";
import ReportSetting from "./ReportSetting";

const ReportsApp = () => {
  const dispatch = useDispatch();
  const { projectId, dashboardId, reportId }: any = useParams();

  const reports = useSelector((state: any) => state.report.get("reports")) || fromJS([]);
  const report = reports.find((widget: any) => widget.get("id") === reportId);

  useEffect(() => {
    if (report) {
      document.title = report.getIn(["data", "title"]) || "Report Setting";
    }
  }, [report]);

  useEffect(() => {
    if (projectId) {
      dispatch(ReportAction.getReports(projectId));
    }
  }, [projectId]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <ReportSetting
      projectId={projectId}
      dashboardId={dashboardId}
      reportId={reportId}
      report={report}
    />
  );
};

export default ReportsApp;
